import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check, Lock, Download, ShieldCheck } from 'lucide-react';
const stackItems = [{
  title: 'La Biblia de 500 Prompts',
  subtitle: 'Edición Profesional',
  value: 37
}, {
  title: 'Bono 01 · 100 Hooks Virales',
  subtitle: 'Listos para usar',
  value: 19
}, {
  title: 'Bono 02 · 30 Días de Contenido',
  subtitle: 'Para Instagram',
  value: 19
}, {
  title: 'Bono 03 · Haz que la IA Suene Como Tú',
  subtitle: 'Framework de tono',
  value: 19
}];
const totalValue = stackItems.reduce((acc, item) => acc + item.value, 0); // 94
const finalPrice = 27;
const savingsPercent = Math.round((totalValue - finalPrice) / totalValue * 100); // ~71%
export function Pricing() {
  return <section id="precio" className="py-24 md:py-32 relative overflow-hidden border-y border-gold/10" data-id="element-236">
      {/* Cinematic background */}
      <div className="absolute inset-0 bg-black" data-id="element-237">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-[radial-gradient(circle_at_center,rgba(212,175,122,0.18)_0%,transparent_60%)] blur-3xl pointer-events-none" data-id="element-238"></div>
        <div className="absolute inset-0 opacity-[0.015] mix-blend-overlay pointer-events-none" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\")"
      }} data-id="element-239"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-240">
        {/* Eyebrow + Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 md:mb-20" data-id="element-241">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold/30 bg-gold/5 backdrop-blur-sm mb-6" data-id="element-242">
            <div className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-243"></div>
            <span className="text-gold text-[10px] uppercase tracking-[0.2em] font-medium" data-id="element-244">
              Oferta de Lanzamiento
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl text-cream mb-6 leading-[1.05]" data-id="element-245">
            Todo esto, por{' '}
            <span className="text-gold italic" data-id="element-246">menos de lo que cuesta</span> un
            almuerzo.
          </h2>
          <p className="text-cream/60 max-w-2xl mx-auto text-lg font-light" data-id="element-247">
            Un pago único. Acceso de por vida. Sin suscripciones, sin letra
            pequeña.
          </p>
        </motion.div>

        {/* Main Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative" data-id="element-248">
          {/* Glow underneath card */}
          <div className="absolute -inset-px bg-gradient-to-br from-gold/40 via-gold/10 to-transparent rounded-sm blur-md opacity-60 pointer-events-none" data-id="element-249"></div>

          <div className="relative bg-gradient-to-br from-black-100 to-black border border-gold/20 rounded-sm overflow-hidden shadow-2xl" data-id="element-250">
            {/* Top hairline */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" data-id="element-251"></div>

            {/* Savings Seal — rotated in top-right corner */}
            <motion.div initial={{
            opacity: 0,
            rotate: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            rotate: 12,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6,
            duration: 0.6,
            type: 'spring'
          }} className="absolute top-6 right-6 md:top-8 md:right-8 z-20" data-id="element-252">
              <div className="relative" data-id="element-253">
                <div className="absolute inset-0 bg-gold/30 blur-xl rounded-full" data-id="element-254"></div>
                <div className="relative bg-gold text-black px-5 py-3 rounded-sm border-2 border-gold-light shadow-[0_0_30px_rgba(212,175,122,0.5)] flex flex-col items-center leading-none" data-id="element-255">
                  <span className="font-display text-3xl md:text-4xl font-bold" data-id="element-256">
                    {savingsPercent}%
                  </span>
                  <span className="text-[9px] uppercase tracking-[0.2em] mt-1" data-id="element-257">
                    Ahorras
                  </span>
                </div>
              </div>
            </motion.div>

            <div className="grid lg:grid-cols-5 gap-0" data-id="element-258">
              {/* LEFT: Value Stack */}
              <div className="lg:col-span-3 p-8 md:p-12 lg:border-r lg:border-gold/10" data-id="element-259">
                <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-6" data-id="element-260">
                  Lo que recibes hoy
                </p>

                <div className="space-y-5" data-id="element-261">
                  {stackItems.map((item, idx) => <motion.div key={idx} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.2 + idx * 0.1
                }} className="flex items-start justify-between gap-4 pb-5 border-b border-white/5 last:border-b-0" data-id="element-262">
                      <div className="flex items-start gap-4 flex-1" data-id="element-263">
                        <div className="w-6 h-6 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0 mt-1" data-id="element-264">
                          <Check size={12} className="text-gold" data-id="element-265" />
                        </div>
                        <div data-id="element-266">
                          <h4 className="text-cream font-medium text-base leading-snug" data-id="element-267">
                            {item.title}
                          </h4>
                          <p className="text-cream/40 text-xs mt-1 font-light" data-id="element-268">
                            {item.subtitle}
                          </p>
                        </div>
                      </div>
                      <span className="text-cream/40 line-through text-sm font-light shrink-0 pt-1" data-id="element-269">
                        ${item.value}
                      </span>
                    </motion.div>)}
                </div>

                {/* Total Value */}
                <motion.div initial={{
                opacity: 0
              }} whileInView={{
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.8
              }} className="mt-8 pt-6 border-t border-gold/20 flex items-center justify-between" data-id="element-270">
                  <span className="text-cream/60 text-sm uppercase tracking-widest" data-id="element-271">
                    Valor total
                  </span>
                  <span className="text-cream/50 line-through text-2xl font-display" data-id="element-272">
                    ${totalValue}
                  </span>
                </motion.div>
              </div>

              {/* RIGHT: Final Price + CTA */}
              <div className="lg:col-span-2 p-8 md:p-12 bg-gradient-to-br from-black to-black-200 flex flex-col justify-center relative overflow-hidden" data-id="element-273">
                {/* Subtle inner glow */}
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,175,122,0.08)_0%,transparent_70%)] pointer-events-none" data-id="element-274"></div>

                <div className="relative z-10 text-center lg:text-left" data-id="element-275">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-3" data-id="element-276">
                    Tu inversión hoy
                  </p>

                  <div className="flex items-baseline justify-center lg:justify-start gap-2 mb-2" data-id="element-277">
                    <span className="text-gold/40 text-xl font-display align-top mt-3" data-id="element-278">
                      USD
                    </span>
                    <motion.span initial={{
                    opacity: 0,
                    scale: 0.9
                  }} whileInView={{
                    opacity: 1,
                    scale: 1
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.5,
                    duration: 0.8,
                    ease: [0.16, 1, 0.3, 1]
                  }} className="font-display text-7xl md:text-8xl text-gold leading-none" style={{
                    textShadow: '0 0 40px rgba(212,175,122,0.4)'
                  }} data-id="element-279">
                      ${finalPrice}
                    </motion.span>
                  </div>

                  <p className="text-cream/50 text-xs uppercase tracking-widest mb-8" data-id="element-280">
                    Pago único · Acceso de por vida
                  </p>

                  <Button variant="primary" className="w-full !py-5 text-base" data-id="element-281">
                    Obtener Acceso Ahora
                  </Button>

                  {/* Trust row */}
                  <div className="mt-8 space-y-3" data-id="element-282">
                    <div className="flex items-center gap-3 text-cream/60 text-xs" data-id="element-283">
                      <Download size={14} className="text-gold/70 shrink-0" data-id="element-284" />
                      <span data-id="element-285">Descarga inmediata después del pago</span>
                    </div>
                    <div className="flex items-center gap-3 text-cream/60 text-xs" data-id="element-286">
                      <Lock size={14} className="text-gold/70 shrink-0" data-id="element-287" />
                      <span data-id="element-288">Pago 100% seguro y encriptado</span>
                    </div>
                    <div className="flex items-center gap-3 text-cream/60 text-xs" data-id="element-289">
                      <ShieldCheck size={14} className="text-gold/70 shrink-0" data-id="element-290" />
                      <span data-id="element-291">Garantía de satisfacción 7 días</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom hairline */}
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-292"></div>
          </div>
        </motion.div>

        {/* Subtle urgency line below */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 1
      }} className="text-center text-cream/40 text-xs uppercase tracking-[0.3em] mt-10" data-id="element-293">
          Precio especial de lanzamiento · Sujeto a aumentar sin previo aviso
        </motion.p>
      </div>
    </section>;
}